import { render, staticRenderFns } from "./TableRiskAppraisal_3x3_miras.vue?vue&type=template&id=65293538&scoped=true"
import script from "./TableRiskAppraisal_3x3_miras.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal_3x3_miras.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal_3x3_miras.vue?vue&type=style&index=0&id=65293538&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65293538",
  null
  
)

export default component.exports